import messages_en from "./en.json";
import messages_es from "./es.json";

export const defaultLanguageCode = 'en';

export const translatedMessages = {
  [defaultLanguageCode]: messages_en,
  'es': messages_es
};
